import React from "react";
import PropTypes from "prop-types";

import {
  ALL_LOCATION_TANKS_QUERY,
  LOCATION_TANK_PAGINATION_QUERY
} from "../../graphql/Locations/LocationTanks.graphql";

import EditLocationTankForm from "./EditLocationTankForm";
import DataTable from "../DataTable";

const COLUMNS = [
  {
    Header: "Description",
    accessor: "Description"
  },
  {
    Header: "Quantity",
    accessor: "Quantity"
  },
  {
    Header: "Size",
    accessor: "Size"
  }
];
function LocationTanksTable({ id, setModalOpen }) {
  const LocationRecIdRef = parseInt(id);

  return (
    <DataTable
      columns={COLUMNS}
      dataQuery={ALL_LOCATION_TANKS_QUERY}
      initialSortBy={[{ id: "Description", desc: true }]}
      name="LocationTank"
      paginationQuery={LOCATION_TANK_PAGINATION_QUERY}
      where={{ LocationRecIdRef }}
      onRowClick={tank =>
        setModalOpen(
          true,
          <EditLocationTankForm
            id={LocationRecIdRef}
            tank={tank}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
}

LocationTanksTable.propTypes = {
  id: PropTypes.number,
  setModalOpen: PropTypes.func
};
export default LocationTanksTable;
